<template>
    <form class="formInput">
        <table class="tableForm">
            <tbody>
            <tr>
                <td class="tdInput" :class='classObjectTd'>
                    <input type="text" :class="classObjectInput" :placeholder="insideText"
                           @focus="touched = true" :value="value" v-imask="maskField" @accept="onAccept">
                </td>
            </tr>
            </tbody>
        </table>
    </form>
</template>

<script>
import { IMaskDirective } from 'vue-imask';

export default {
    name: 'InputValidation',

    props: {
        insideText:[String, Number],
        isValid: Boolean,
        ignoreTouchedProps: Boolean,
        value: [String, Number],
        mask: {
            type: String,
            default: '',
        },
    },

    data () {
        return {
            touched: false,
        };
    },

    directives: {
        imask: IMaskDirective,
    },

    methods: {
        onAccept (e) {
            this.touched = true;
            this.$emit('input', e.detail.value);
        },
    },

    computed: {
        classObjectTd() {
            if (!this.ignoreTouchedProps) {
                return {
                    'tdInputCorrect': this.isValid && this.touched,
                    'tdInputIncorrect': !this.isValid && this.touched,
                };
            } else {
                return {
                    'tdInputCorrect': this.isValid,
                    'tdInputIncorrect': !this.isValid,
                };
            }
        },

        classObjectInput() {
            if (!this.ignoreTouchedProps) {
                return {
                    'formInputCorrect': this.isValid && this.touched,
                    'formInputIncorrect': !this.isValid && this.touched,
                };
            } else {
                return {
                    'formInputCorrect': this.isValid,
                    'formInputIncorrect': !this.isValid,
                };
            }
        },

        maskField() {
            return {
                mask: this.mask ? this.mask : false,
                lazy: true,
            };
        },
    },
};
</script>

<style scoped>

    .tableForm {
        border-collapse: separate;
        border-spacing: 0;
    }

    .tdInput {
        padding: 15px 40px 5px 3px;
        vertical-align: baseline;
    }

    input {
        padding: 4px;
        width: 170px;
        background: none;
        margin-top: -10px;
        outline: none;
        caret-color: black;
        border-width: 1px;
    }

    .tdInputCorrect {
        background-position: 200px 10px;
        background-repeat: no-repeat;
        background-image: url('./img/done.png');
    }

    .tdInputIncorrect {
        line-height: 1;
        color: black;
        border-collapse: separate;
        border-spacing: 0;
        margin: 0;
        border: 0;
        outline: 0;
        font-style: inherit;
        font-size: 100%;
        vertical-align: baseline;
        text-align: left;
        font-weight: normal;
        padding: 15px 40px 5px 3px;
        background-position: 200px 10px;
        background-repeat: no-repeat;
        background-image: url('./img/fail.png');
    }

    .formInputCorrect {
        border: 1px solid #B0D638;
        box-shadow: #B0D638 0 0 4px;
        padding: 4px;
        width: 170px;
        margin-top: -10px;
        color: #999;
    }

    .formInputIncorrect {
        border-collapse: separate;
        border-spacing: 0;
        border: 1px solid #D21C1C;
        box-shadow: #D21C1C 0 0 4px;
        padding: 4px;
        width: 170px;
        background: none;
        margin: -10px 0 0;
        color: #999;
    }

    .formInput {
        text-align: center;
    }
</style>
